import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from './HomeComponent.module.css';
import { FaPlay, FaPause, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../../Images/logoformeta.png';
import logofotter from '../../Images/footerImg.png';
import toxboxlog from "../../Images/toxboxlogo.png";
import About from '../About/About';
import audio1 from '../../Images/audio1.mp3';
import audio2 from '../../Images/2.mp3';
import audio3 from '../../Images/3.mp3';
import audio4 from '../../Images/4.mp3';
import audio5 from '../../Images/5.mp3';
import audio6 from '../../Images/6.mp3';
import FAQComponent from '../faqsData/faqsData';
import FooterComponent from '../Footer/FooterComponent';
import Features from './Features';
import Features2 from './Features2';
import boat from '../../Images/robot.png';
import BookDemoCall from './BookDemoCall/BookDemoCall';
import VoiceDemo from './VoiceDemo/VoiceDemo';
import Subscriptions from '../Subscription/Subscription';
import Avatar from '../Avatar/Avatar';
import arrow from '../../Images/Arrow.png';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import VoicePopup from '../VoicePopup/VoicePopup';
import NetworkUI from '../../Components/NetworkUI/NetworkUI';
import CustomAudioPlayer from './CustomAudioPlayer';
import video from './home.mp4';
import GooeyNav from './GooeyNav';
import Navbar from './Navbar';
import IndustriesSection from './IndustriesSection';
import FallingText from '../FallingText/FallingText';
import LandingPage from '../../NewCompoents/LandingPage/LandingPage';
import AgentDiagram from '../AgentDiagram/AgentDiagram';
import Flow from '../AgentDiagram/Flow';
import FlowDiagram from '../AgentDiagram/FlowDiagram';
import ChatBox from '../ChatBox/ChatBox';
import NewChatBot from "../NewChatbot/NewChatBot";

import Orb from "./Orb"

gsap.registerPlugin(ScrollTrigger);

const HomeComponent = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const subscriptionsRef = useRef(null);
  const aboutRef = useRef(null);
  const gsapContext = useRef(null);
  const navigate = useNavigate();
  const [selectedAgent, setSelectedAgent] = useState(null);

  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    gsapContext.current = gsap.context(() => {
      // Hero Section: Video Fade-In
      gsap.fromTo(
        '.hero video',
        { opacity: 0 },
        {
          opacity: 1,
          duration: 1.5,
          ease: 'power2.out',
        }
      );

      // Hero Section: Staggered Text Entrance
      gsap.fromTo(
        '.hero h1, .hero p, .hero button',
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: '.hero',
            start: 'top 90%',
            end: 'top 20%',
            scrub: true,
          },
        }
      );

      // Team Section: Staggered Agent Cards
      // gsap.fromTo(
      //   '.teamSection .agentCard', // Assuming NetworkUI renders elements with class 'agentCard'
      //   { scale: 0.8, opacity: 0 },
      //   {
      //     scale: 1,
      //     opacity: 1,
      //     duration: 0.8,
      //     stagger: 0.2,
      //     ease: 'back.out(1.7)',
      //     scrollTrigger: {
      //       trigger: '.teamSection',
      //       start: 'top 80%',
      //       end: 'top 20%',
      //       scrub: true,
      //     },
      //   }
      // );

      // Team Section: Staggered Agent Nodes (from NetworkUI)
const animateTeamSection = () => {
  const agentNodes = document.querySelectorAll('.teamSection .node');

  if (agentNodes.length > 0) {
    gsap.fromTo(
      agentNodes,
      { scale: 0.8, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 0.8,
        stagger: 0.2,
        ease: 'back.out(1.7)',
        scrollTrigger: {
          trigger: '.teamSection',
          start: 'top 80%',
          end: 'top 20%',
          scrub: true,
        },
      }
    );
  } else {
    // Retry shortly until elements are rendered
    setTimeout(animateTeamSection, 300);
  }
};

animateTeamSection();


      // Industries Section: Slide-In Panels
      gsap.fromTo(
        '.industriesSection .industryPanel', // Assuming IndustriesSection renders elements with class 'industryPanel'
        { x: -100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.3,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.industriesSection',
            start: 'top 80%',
            end: 'top 20%',
            scrub: true,
          },
        }
      );

      // Features Section: Card Flip Effect
      gsap.fromTo(
        '.features > div', // Targeting feature cards
        { rotationY: 90, opacity: 0 },
        {
          rotationY: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.3,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: '.features',
            start: 'top 70%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      // Demo Grid: Audio Players Pop-In
      gsap.fromTo(
        '.demoGrid .audioGroup1, .demoGrid .audioGroup2, .demoGrid .audioGroup3, .demoGrid .audioGroup4, .demoGrid .audioGroup5, .demoGrid .audioGroup6',
        { scale: 0.5, rotation: 10, opacity: 0 },
        {
          scale: 1,
          rotation: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.2,
          ease: 'elastic.out(1, 0.5)',
          scrollTrigger: {
            trigger: '.demoGrid',
            start: 'top 80%',
            end: 'top 20%',
            scrub: true,
          },
        }
      );

      // Problems Section: List Item Fade and Slide
      gsap.fromTo(
        '.problemsSection li',
        { x: 50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.problemsSection',
            start: 'top 80%',
            end: 'top 20%',
            scrub: true,
          },
        }
      );

      // Footer: Logo and Links Animation
      gsap.fromTo(
        '.footer img, .footer a', // Assuming FooterComponent renders img and a tags
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: '.footer',
            start: 'top 90%',
            end: 'top 30%',
            scrub: true,
          },
        }
      );

      // Existing Animations (kept for reference, no changes needed)
      gsap.fromTo(
        '.hero h1',
        { scale: 0.5, transform: 'translateZ(50px)', opacity: 1 },
        {
          scale: 1,
          transform: 'translateZ(0)',
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: '.hero h1',
            start: 'top 80%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '.hero p',
        { scale: 0.9, y: 10, opacity: 0.5 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1.2,
          delay: 0.3,
          scrollTrigger: {
            trigger: '.hero p',
            start: 'top 80%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '.hero button',
        { scale: 0.7, opacity: 1 },
        {
          scale: 1,
          opacity: 1,
          duration: 0.8,
          delay: 0.6,
          scrollTrigger: {
            trigger: '.hero button',
            start: 'top 90%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '.features > *',
        { y: 200, opacity: 1 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.3,
          scrollTrigger: {
            trigger: '.features',
            start: 'top 70%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '.wrapper .demoGrid > *',
        { scale: 0.6, opacity: 1 },
        {
          scale: 1,
          opacity: 1,
          duration: 1,
          stagger: 0.2,
          scrollTrigger: {
            trigger: '.wrapper .demoGrid > *',
            start: 'top 80%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '.arrow',
        { rotate: -180, scale: 0, opacity: 1 },
        {
          rotate: 360,
          scale: 1,
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: '.arrow',
            start: 'top 80%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '#demo',
        { scale: 0.8, y: 50, opacity: 1 },
        {
          scale: 1,
          y: 0,
          opacity: 1,
          duration: 1.2,
          scrollTrigger: {
            trigger: '#demo',
            start: 'top 80%',
            end: 'top 10%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '#demoSection',
        { scale: 0.8, y: 200, opacity: 1 },
        {
          scale: 1,
          y: 0,
          opacity: 1,
          duration: 1.2,
          scrollTrigger: {
            trigger: '#demoSection',
            start: 'top 100%',
            end: 'top 60%',
            scrub: 1,
          },
        }
      );

      gsap.fromTo(
        '#demoImage',
        { scale: 0.8, rotate: 180, opacity: 1 },
        {
          scale: 1,
          rotate: 0,
          opacity: 1,
          duration: 1.2,
          scrollTrigger: {
            trigger: '#demoImage',
            start: 'top 80%',
            end: 'top 10%',
            scrub: 1,
          },
        }
      );
    });

    return () => gsapContext.current && gsapContext.current.revert();
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSubscriptions = () => {
    subscriptionsRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToAbout = () => {
    aboutRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={styles.container}>
      {[...Array(17)].map((_, i) => (
        <div key={i} className={`${styles.bubble} ${styles[`bubble${i + 1}`]}`} />
      ))}
      <Navbar />

      <section id="home" className={`${styles.hero} hero`}>
        <div className={styles.content}>
         <video
            autoPlay
            muted
            loop
            className={styles.backgroundVideo}
          >
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* <div style={{ width: '100%', height: '600px', position: 'absolute' }} >
            <Orb
              hoverIntensity={0.5}
              rotateOnHover={true}
              hue={0.9}
              forceHoverState={false}
            />
          </div> */}
          <h1 className={styles.title}>
            ToxBox – Your 24/7 AI-Powered Calling Agents for Smarter Results
          </h1>
          <p className={styles.description}>
            Say goodbye to missed calls, high operational costs, and inconsistent customer service. ToxBox is your intelligent AI phone assistant, designed to handle calls, respond instantly, and manage appointments around the clock—empowering your business to focus on growth.
          </p>
          <button
            onClick={() => navigate('/demo-form')}
            className={styles.getStarted}
          >
            <span className={styles.get}>Get Started Now</span>
          </button>
        </div>
      </section>

      <section className={`${styles.teamSection} teamSection`}>
        <h2 className={styles.teamTitle}>Meet Your AI Team</h2>
        <p>Our specialized AI agents are tailored to meet your business needs with precision and efficiency.</p>
        <NetworkUI selectedAgent={selectedAgent} setSelectedAgent={setSelectedAgent} />
      </section>

      {/* <Flow /> */}
      {/* <FlowDiagram /> */}

      {/* <AgentDiagram /> */}

      <section className={`${styles.teamSection} industriesSection`}>
        <h2 className={styles.teamTitle}>Industry-Tailored Solutions</h2>
        <p>ToxBox delivers customized communication solutions across diverse industries, streamlining operations and enhancing customer experiences.</p>
        <IndustriesSection />
      </section>

      <div className={styles.demoText}>
        <p className={styles.afterwatch}>What Sets Us Apart</p>
        <p className={styles.afterwatch2}>Results that speak for themselves.</p>
      </div>

      <div className="features">
        <Features2 />
      </div>

      <div className="features">
        <Features />
      </div>

      <section className={`${styles.problemsSection} problemsSection`}>
        <h2>Solving Your Toughest Challenges</h2>
        <p>ToxBox addresses critical communication pain points, delivering efficiency, scalability, and customer satisfaction.</p>
        <ul>
          <li><strong>Missed Calls & Lost Revenue</strong><br />Unanswered calls during off-hours or peak times lead to lost customers. ToxBox’s 24/7 AI ensures every call is handled, boosting retention and revenue.</li>
          <li><strong>High Operational Costs</strong><br />Staffing large call centers is expensive. ToxBox automates repetitive tasks, reducing the need for additional hires while maintaining quality.</li>
          <li><strong>Slow Response Times</strong><br />Customers expect instant answers. ToxBox’s smart call routing and AI responses cut resolution times by 30%, keeping customers happy.</li>
          <li><strong>Inconsistent Service Quality</strong><br />Human agents can vary in performance. ToxBox delivers consistent, personalized interactions with customizable voice and tone.</li>
          <li><strong>Language Barriers</strong><br />Global customers demand multilingual support. ToxBox communicates fluently in 10+ languages, expanding your reach effortlessly.</li>
        </ul>
      </section>

      <section>
        <LandingPage />
      </section>

      <section className={`${styles.wrapper} wrapper`}>
        <h2 className={styles.title}>Voices That Speak Your Industry</h2>
        <p className={styles.subtitle}>
          Experience cutting-edge voice solutions tailored for every domain — faster, smarter, and ready to perform.
        </p>

        <div className={`${styles.demoGrid} demoGrid`}>
          <div className={styles.audioGroup1}>
            <CustomAudioPlayer src={audio1} label="Bank" />
          </div>
          <div className={styles.audioGroup2}>
            <CustomAudioPlayer src={audio2} label="Hospital" />
          </div>
          <div className={styles.imageContainer}>
            <img src={boat} alt="Robot Demo" />
          </div>
          <div className={styles.audioGroup3}>
            <CustomAudioPlayer src={audio3} label="Debt collection" />
          </div>
          <div className={styles.audioGroup4}>
            <CustomAudioPlayer src={audio4} label="Receptionist" />
          </div>
          <div className={styles.audioGroup5}>
            <CustomAudioPlayer src={audio5} label="Dealership" />
          </div>
          <div className={styles.audioGroup6}>
            <CustomAudioPlayer src={audio6} label="Customer Support" />
          </div>
        </div>
        <button
          onClick={() => navigate('/audios')}
          className={styles.ctaButton}
        >
          <span className={styles.gradientText}>Explore Feature</span>
        </button>
      </section>

      <VoiceDemo />

      <div id="pricing">
        <About ref={aboutRef} />
        <FAQComponent />
        {/* <FooterComponent /> */}
        <VoicePopup selectedAgent={selectedAgent} />
      </div>
    </div>
  );
};

export default HomeComponent;